import styled, { keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';
import colors from '../../includes/colors';

export const OpenMenu = keyframes`
  0% {
    transform: translateX(100%)
  }
  100% {
    transform: translateX(0)
  }
`;

export const Title = styled.h1`
  color: ${colors.black};
  line-height: 2.5rem;
  font-weight: 300;
  font-size: 1.5rem;
  @media (min-width: 576px) {
    font-size: 1.875rem;
  }
  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

export const FaqPageBlock = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  padding-bottom: ${({category}) => category ? '0' : '1.5rem'};
  @media (min-width: 993px) {
    padding-bottom: 1.5rem;
  }
`;

export const SearchBlock = styled.div`
  height: 100%;
  background: #fff;
  animation: ${OpenMenu} 0.5s ease forwards;
  @media (min-width: 993px) {
    animation: none;
    height: auto;
  }
`;

export const BackButton = styled(NavLink)`
  display: flex;
  width: 100%;
  padding: 10px 12px;
  background-color: #eee;
  border-bottom: solid 0.0625rem #ccc;
  border-left: solid 0.0625rem #ccc;
  color: ${colors.blue} !important;
  font-size: 0.875rem;
  font-weight: 400;
  span {
    font-size: inherit;
    line-height: inherit;
  }
`;

export const FaqPageCategories = styled.div`
  position: ${({category}) => category ? 'absolute' : 'relative'};
  @media (min-width: 993px) {
    position: relative;
  }
`
